// src/Components/CustomerService_Header.js

import React, { useState, useEffect } from "react";
import { useAuth } from '../../AuthContext';
import { Container, Navbar, Nav } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../Config';  
const CustomerService_Header = () => {
    const { logout } = useAuth(); // Access logout function from AuthContext
    const navigate = useNavigate();
    const [userData, setUserData] = useState(null); // Store user data


    // Load user data from sessionStorage on component mount
    useEffect(() => {
        const user = JSON.parse(sessionStorage.getItem("user"));
        if (user) {
            setUserData(user);
        }
    }, []);

    // Handle logout functionality
    const handleLogout = () => {
        handleLogOutApi()
    };

    const handleLogOutApi = async () => {
        const userId = userData.userId;
        try {
            const response = await axios.post(`${BASE_URL}Retail_Logout`, {
                userId
            }, {
                headers: {
                    'Accept': '*/*',
                    'Content-Type': 'application/json',
                }
            });

            if (response.data.responseCode === "0000") {
                const userData = response.data;
                logout(); // Call logout function from context to reset global auth state
                sessionStorage.removeItem("user");
                // setUserData(null); // Optionally clear user data from state
                console.log('Logout successful'); // Debugging output
                navigate('/');

                // Check the userRole and navigate accordingly

            } else {

            }
        } catch (error) {
            console.error('Logout error:', error);
        }
    };

    return (
        <Navbar expand="lg" className="bg-body-tertiary" style={{ borderRadius: '25px' }}>
            <Container>
                <Navbar.Brand href={`/Company/Company_Dashboard`}>WEBDOC</Navbar.Brand>

                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="w-100 me-auto">
                        {/* Conditionally render logout and user info */}
                        {userData ? (
                            <>
                               
                                {/* <Nav.Link href={`Reversal`}>Reversal </Nav.Link> */}

                                <div className="d-flex ms-auto">
                                    <Nav.Link className="text-end">{userData?.name}</Nav.Link>
                                    <Nav.Link onClick={handleLogout}>Logout</Nav.Link>
                                </div>
                            </>
                        ) : (
                            <Nav.Link href="/">Login</Nav.Link>
                        )}
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default CustomerService_Header;

